// extracted by mini-css-extract-plugin
export default {"staticCardsContainer":"ActivityLogPage_staticCardsContainer__1Alsx"};